import { addTable } from 'views/report/utils/add-table/add-table.ts';
import { padding } from 'views/report/utils/style-consts.ts';
import { getRows } from 'views/report/pages/add-cost-item-afe-overview/utils.ts';
import { TData } from 'views/report/pages/add-cost-item-afe-overview/types.ts';

export const addCostItemAfeOverview = ({ doc, simulationsResult, costCodesIdToCodeMap }: TData) => {
  doc.addPage();
  const rows = getRows(simulationsResult, costCodesIdToCodeMap);
  addTable(doc, rows, {
    y: padding * 2,
    headersCount: 1,
    aligns: ['left', 'left', 'right', 'right', 'right', 'right', 'right'],
    hasFirstColumnBoldText: false,
  });
};
